var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hugeicons:briefcase-05"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.8335 16.5L5.063 21.3405C5.309 26.5035 5.432 29.0835 7.172 30.6675C8.912 32.25 11.624 32.25 17.051 32.25H19.616C25.043 32.25 27.7565 32.25 29.495 30.6675C31.235 29.0835 31.358 26.5035 31.604 21.3405L31.8335 16.5",
    stroke: "#038CEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.60412 15.6645C7.15412 20.511 12.9036 22.5 18.3336 22.5C23.7636 22.5 29.5131 20.511 32.0631 15.6645C33.2796 13.3515 32.3586 9 29.3616 9H7.30562C4.30862 9 3.38762 13.35 4.60562 15.6645M18.3336 16.5H18.3471M24.3336 9L24.2016 8.535C23.5416 6.225 23.2116 5.07 22.4256 4.41C21.6396 3.75 20.5956 3.75 18.5091 3.75H18.1581C16.0716 3.75 15.0276 3.75 14.2431 4.41C13.4556 5.07 13.1256 6.225 12.4656 8.535L12.3336 9",
    stroke: "#038CEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.a594decb8e1ba7c57001ea8b1f0de1c0.svg";
export { ForwardRef as ReactComponent };